export const findContactsTransformer = (data) => {
    const transformedPayload = {};
    try {
        const payload = JSON.parse(data);
        payload.Users.forEach((user) => {
            const userKey = `${user.Class}_${user.ID}`;
            transformedPayload[userKey] = {
                id: userKey,
                firstName: user.FirstName,
                lastName: user.LastName,
                clockedIn: user.Online,
                active: true, // default to true
            };
        });
        return transformedPayload;
    } catch (error) {
        // swallow and return the payload as-is so axios can handle it.
    }
    return data;
};

export default findContactsTransformer;
